export const state = {
  navDrawer: false,
  calendarDrawer: false,
  settingsDrawer: false,
}

export const getters = {
  getDrawer: (state) => (drawer) => {
    return state[drawer]
  },
}

export const mutations = {
  SET_DRAWER(state, payload) {
    state[payload.drawer] = payload.value
  },
}

export const actions = {
  setDrawer({ commit, state }, payload) {
    commit('SET_DRAWER', payload)
    return payload
  },
}
